import styles from "../styles/receipt.module.css";

export default function TableFooter({
  page,
  setPage,
  totalPages,
  next,
  previous,
  count = 0,
  loading = false,
}) {
  return (
    <div className={styles["table-footer"]}>
      <p style={{color:"#9ca3af", fontSize:"0.9rem"}}>
        {loading ? (
          <span style={{ color: "#f97316", fontSize: "0.83rem" }}>
            <i
              className="fa-solid fa-circle-notch fa-spin"
              style={{ marginRight: 5 }}
            />
            Cargando...
          </span>
        ) : (
          <>
            <span>{count}</span> resultado(s) · Página <span>{totalPages}</span>{" "}
            de <span>{Math.max(1, totalPages)}</span>
          </>
        )}
      </p>

      <div className={`${styles["pagination-buttons"]} d-flex gap-2`}>
        <button
          disabled={!previous || loading}
          onClick={() => setPage((p) => p - 1)}
          className={`btn btn-sm ${styles["btn-prev"]} d-flex gap-2 align-items-center`}
        >
          Anterior
        </button>
        <button
          disabled={!next || loading}
          onClick={() => setPage((p) => p + 1)}
          className={`btn btn-sm ${styles["btn-next"]} d-flex gap-2 align-items-center`}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
}
